import React from 'react';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  screenName?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(`[ErrorBoundary${this.props.screenName ? ':' + this.props.screenName : ''}]`, error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="min-h-screen bg-[#F7F0EA] flex flex-col items-center justify-center px-6 text-center">
          <p style={{ fontFamily: 'Georgia, serif', fontSize: 22, color: '#2A1A0E', marginBottom: 8 }}>
            Что-то пошло не так
          </p>
          <p style={{ fontSize: 14, color: '#B0A099', marginBottom: 24 }}>
            Попробуйте перезагрузить страницу
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#6E2726',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '12px 32px',
              fontSize: 15,
              cursor: 'pointer',
            }}
          >
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
